"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("../classnames"));
var Icon_1 = __importDefault(require("./Icon"));
var SearchBar = /** @class */ (function (_super) {
    __extends(SearchBar, _super);
    function SearchBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.componentIsMounted = false;
        _this.inputRef = react_1.default.createRef();
        _this.timeout = null;
        _this.state = { search: "", searching: false };
        _this.handleChange = function (event) {
            var onSearchChange = _this.props.onSearchChange;
            var search = event.target.value;
            if (onSearchChange) {
                onSearchChange(search);
            }
            _this.setState({ search: search, searching: search.length > 0 });
        };
        _this.handleClear = function (_) {
            var onSearchChange = _this.props.onSearchChange;
            var search = "";
            if (onSearchChange) {
                onSearchChange(search);
            }
            _this.setState({ search: search, searching: search.length > 0 });
        };
        return _this;
    }
    SearchBar.prototype.componentDidMount = function () {
        this.componentIsMounted = true;
        var autoFocus = this.props.autoFocus;
        var input = this.inputRef.current;
        if (autoFocus && input) {
            input.focus();
        }
    };
    SearchBar.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        var _a = this.props, onSearch = _a.onSearch, throttle = _a.throttle;
        var search = this.state.search;
        if (search !== prevState.search) {
            if (this.timeout) {
                window.clearTimeout(this.timeout);
            }
            if (search) {
                var performSearch = function () { return (onSearch(search) || Promise.resolve()).then(function () {
                    if (_this.componentIsMounted) {
                        _this.setState({ searching: false });
                    }
                }); };
                if (throttle) {
                    this.timeout = window.setTimeout(performSearch, throttle);
                }
                else {
                    performSearch();
                }
            }
            else {
                onSearch(search);
            }
        }
    };
    SearchBar.prototype.componentWillUnmount = function () {
        this.componentIsMounted = false;
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    };
    SearchBar.prototype.render = function () {
        var _a = this.props, className = _a.className, autoComplete = _a.autoComplete, placeholder = _a.placeholder, clearOptionEnabled = _a.clearOptionEnabled;
        var _b = this.state, search = _b.search, searching = _b.searching;
        return (react_1.default.createElement("div", { className: classnames_1.default("chq-sbar", className) },
            react_1.default.createElement(Icon_1.default, { className: "chq-sbar--gls", icon: "ios-search-strong" }),
            react_1.default.createElement("input", { ref: this.inputRef, "aria-label": "Search", type: "search", name: "search", value: search, onChange: this.handleChange, autoComplete: autoComplete, placeholder: placeholder }),
            searching && react_1.default.createElement(Icon_1.default, { className: "chq-sbar--spn", icon: "load-c" }),
            !searching && clearOptionEnabled && search.length > 0 && react_1.default.createElement(Icon_1.default, { className: "chq-sbar--close", icon: "close", onClick: this.handleClear })));
    };
    SearchBar.defaultProps = {
        autoComplete: "on",
        autoFocus: false,
        placeholder: "",
        throttle: 300,
        clearOptionEnabled: false
    };
    return SearchBar;
}(react_1.default.Component));
exports.default = SearchBar;
